export const MESSENGER_RIGHT_BAR_AUTO_HIDE_MAX_WIDTH = 1320;
export function isMessengerViewportNarrow(width) {
    if (typeof window === 'undefined')
        return false;
    return (width ?? window.innerWidth) < MESSENGER_RIGHT_BAR_AUTO_HIDE_MAX_WIDTH;
}
/** Panel phải đang mở (cột cố định hoặc drawer). */
export function isMessengerRightPanelOpen(sel) {
    return sel?.right_bar_visible !== false;
}
/** Cột phải layout cố định (chỉ viewport rộng + panel mở). */
export function isMessengerRightColumnLayoutVisible(sel, width) {
    if (isMessengerViewportNarrow(width))
        return false;
    return isMessengerRightPanelOpen(sel);
}
/** Trạng thái nút toggle / icon panel phải (drawer hoặc cột). */
export function resolveMessengerRightBarVisible(sel) {
    return isMessengerRightPanelOpen(sel);
}
export function normalizeChatGroupSelectedForViewport(sel, width) {
    if (!sel || !isMessengerViewportNarrow(width))
        return sel;
    if (sel.right_bar_visible === false)
        return sel;
    return { ...sel, right_bar_visible: false };
}
